import { render, staticRenderFns } from "./results-controls.vue?vue&type=template&id=b68e4e90&scoped=true&"
import script from "./results-controls.vue?vue&type=script&lang=js&"
export * from "./results-controls.vue?vue&type=script&lang=js&"
import style0 from "./results-controls.vue?vue&type=style&index=0&id=b68e4e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68e4e90",
  null
  
)

export default component.exports